import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import "./payment.css";
import { orderStatus } from "../../services/apiService";
 
const Success = () => {
  const { id } = useParams<{ id: any }>();
  const location = useLocation();
  const locationPath = location.pathname.startsWith('/success');
  const navigate = useNavigate();
  const selectedPlan = React.useMemo(() => {
    const plan = localStorage.getItem("selectedPlan");
    return plan ? JSON.parse(plan as any) : {};
  }, []);
  const [Payments, setPayments] = React.useState<any>({
    apply: true,
    data: selectedPlan,
  });
  const orderID = localStorage.getItem("orderId");

  useEffect(()=>{
      fetchOrderStatus();
  }, [id, locationPath]);

  const fetchOrderStatus = async () =>{
    try{
      const response = await orderStatus(orderID as string);
      console.log(response, 'response');
      if(response.data?.payment_status === 'PAYMENT_SUCCESS' || response.data?.payment_status === 'paid'){
        setPayments({
          apply: true,
          data: selectedPlan,
          
        });
      }else{
        setPayments({
          apply: false,
          data: selectedPlan,
          errorStatus: response.data?.payment_status
        });
      }
    } catch (error) {
      console.error("Error fetching order status:", error);
      setPayments({
        apply: false,
        data: {},
        errorStatus: 'PAYMENT_ERROR'
      });
    }
  }


 
  React.useEffect(() => {
    if (selectedPlan && selectedPlan.total_amount) {
      setPayments({
        apply: true,
        data: selectedPlan,
      });
    } else {
      navigate("/home");
    }
  }, [id, navigate, selectedPlan]);

 
  return (
    <Box className="centered-success-container">
      <Box className="paymentMessageContainerSuccess">
        {Payments.apply ? (
          <>
            <img
              src={'/assets/paymentSuccess.svg'}
              alt="Payment Success"
              className="PaymentImage"
            />
            <Typography variant="body2" className="paymentMessageText">
              Payment Successful
            </Typography>
            <Typography
              variant="body2"
              component="p"
              className="paymentMessageText"
            >
              Thank You! Your payment of {Payments?.data?.selectedCurrency === "INR"
                ? `₹${Payments?.data?.total_amount}`
                : `$${Payments?.data?.total_amount}`} has been made successfully for&nbsp;
              {Payments?.data?.credit_points} credits
            </Typography>
            {(Payments?.data?.phonepe_payment_id || Payments?.data?.stripe_payment_id) && (
              <Typography variant="body2" className="paymentMessageText">
                Transaction ID: {Payments.data.phonepe_payment_id || Payments.data.stripe_payment_id}
              </Typography>
            )}
            <Button
              variant="contained"
              sx={{ bgcolor: "#6A1B9A", width: "80px", mt: 1 }}
              className="modalButton"
              onClick={() => {
                navigate("/home");
                localStorage.removeItem("selectedPlan");
                localStorage.removeItem("orderId");
              }}
            >
              Explore Showcasa
            </Button>
          </>
        ) : (
          <>
            <img
              src={'/assets/paymentFailed.svg'}
              alt="Payment Failed"
              className="PaymentImage"
            />
            <Typography variant="body2" className="paymentMessageText" color="error">
              Payment Failed
            </Typography>
            <Typography
              variant="body2"
              component="p"
              className="paymentMessageText"
            >
              Please try again. your payment failed and no charges were made
            </Typography>
            
            <Button
              variant="contained"
              sx={{ bgcolor: "#d32f2f", width: "80px", mt: 1 }}
              className="modalButton"
              onClick={() => {
                navigate("/subscription");
                localStorage.removeItem("orderId");
                localStorage.removeItem("selectedPlan");
              }}
            >
              Try Again
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};
 
export default Success;